import React, { useEffect, useState } from "react"
import * as TrinityAPI from "../../../../requests/TrinityAPI"
import { ICurrency } from "../../../../types/dict/ICurrency"
import { IErrorModel } from "../../../../types/error/IErrorModel"
import clsx from "clsx"

export const CurrencyPicker: React.FC<{
  label?: string
  name: string
  errorModel: IErrorModel | undefined
  initValue: string | undefined
  _callback: (currency: string) => void
  clazzName?: string
}> = ({ label, name, errorModel, initValue, _callback, clazzName }) => {
  const [currency, setCurrency] = useState<ICurrency>()
  const [currencyList, setCurrencyList] = useState<ICurrency[]>([])
  const [currencyCode, setCurrencyCode] = useState(initValue)

  useEffect(() => {
    if (initValue) {
      setCurrencyCode(initValue)
      setCurrency({ code: initValue })
    }
  }, [initValue])

  const handleChangeCurrency = (currency: string) => {
    setCurrencyCode(currency)
    TrinityAPI.suggestCurrency(currency, response => {
      if (response.status === 200) {
        setCurrencyList(response.data)
      }
    })
  }

  const pickCurrency = (currency: ICurrency) => {
    setCurrencyCode("")
    setCurrency(currency)
    setCurrencyList([])
    _callback(currency.code)
  }

  const removeCurrency = (currency: ICurrency | undefined) => {
    setCurrency(undefined)
    setCurrencyCode("")
    _callback("")
  }

  const getFieldError = (fieldName: string) => {
    if (errorModel && errorModel.fieldErrors.filter(fe => fe.field === fieldName).length > 0) {
      return errorModel.fieldErrors.filter(fe => fe.field === fieldName)[0].defaultMessage
    }
  }

  return (
    <fieldset className={clsx(clazzName ? clazzName : "", "select-fieldset")}>
      {label && <legend>{label}</legend>}
      {currency ? (
        <></>
      ) : (
        <input
          type="text"
          className="input-form"
          placeholder="К примеру USD"
          onChange={e => handleChangeCurrency(e.target.value)}
          value={currencyCode}
        />
      )}
      <ul className="prompt-list">
        {currencyList.map((c, index) => (
          <li className="promp-item" key={index} onClick={() => pickCurrency(c)}>
            {c.code} ({c.name})
          </li>
        ))}
      </ul>

      <ul className="tag-list">
        {currency ? (
          <li className="tag-item">
            {currency.code}
            <span className="close-country" onClick={() => removeCurrency(currency)} />
          </li>
        ) : (
          <></>
        )}
      </ul>
      {getFieldError(name) ? <p className="error-form">{getFieldError(name)}</p> : <></>}
    </fieldset>
  )
}
